const endpoints = {
  GET_PINCODE_DETAILS: '/v8/services/get_geolocation_coordinates',
  GET_MEDICAL_CONDITIONS: '/v8/services/get_medical_condition_group_list',
  SUBMIT_PATIENT_DETAILS: '/v8/services/generate_razorpay_payments_link',
  REQUEST_CALLBACK: '/v8/patient/request_callback_campaign_info',
  Auth: {
    SEND_OTP: '/v8/otp/send',
    VERIFY_OTP: '/v8/otp/verify',
    LOGIN_OR_REGISTER_PATIENT: '/v8/patient/register_or_login',
    UPDATE_USER: '/v8/patient/update_profile',
  },
  CarePlan: {
    FETCH_CARE_PLANS: '/v8/goodflip/care-plan/plans',
    // APPLY_COUPON: '/check_discount',
    // GENERATE_RAZORPAY_ORDER_ID: '/razorpay_order_id',
    // ASSIGN_PLAN: '/add_patient_plan',
  },
  Questionnaire: {
    // GET_QUESTIONS: '/questionnaire',
    // SUBMIT_ANSWER: '/answer',
    // GET_SCORE: '/score',
  },
  Goals: {
    // GET_USER_GOALS: '/goals',
  },
  Diagnostics: {
    UPDATE_ADDRESS: '/v8/tests/update_address',
    BOOK_TEST: '/v8/tests/book_lab_tests_goodflip',
    GET_APPOINTMENT_SLOTS: '/v8/tests/get_appointment_slots',
    ADD_TO_CART: '/v8/tests/add_to_cart',
    CONFIRM_ORDER: '/v8/tests/confirm_order',
    GET_RECORDS: '/v8/patient/get_records',
  },
  Pincodes: {
    GET_LAT_LONG_BY_PINCODE: '/v8/tests/get_lat_long',
  },
  Achieve: {
    // GET_PATIENT_LATEST_SCORE: '/get_patient_latest_score',
    // GET_PATIENT_GOALS: '/get_patient_goals',
    // GET_PATIENT_SCORE_TIMELINE: '/get_patient_score_timeline',
    // GET_PATIENT_GOAL_INFO: '/get_patient_goal_info_basis_assessment',
    // GET_PATIENT_GOAL_INFO: '/get_patient_goal_info_basis_assessment'
  },
  PNDS: {
    GENERATE_PNDS_SCORE: '/calculate_pnds',
  },
  SendEventData: {
    SEND_DATA: '/v8/patient/track_ckd_events',
  },
}

export default endpoints
